//Инициализация простых карт на основе данных их атрибутов в вёрстке.
function simple_map_init(el, center, zoom) {
	var map_cont = $(el);

    var ymap = new ymaps.Map(map_cont[0], {
        center: [center[0], center[1]],
        zoom: zoom,
        controls: ['zoomControl', 'fullscreenControl']
    });

    ymap.behaviors.disable('scrollZoom');

    return ymap;
}

//Добавление маркера на карту.
function marker_add_on_map(map_object, point_coords){
    var iconImageSize = [53, 70];
    var iconImageOffset = [-25, -65];
    if (ww < 768) {
        iconImageSize = [28, 39];
        iconImageOffset = [-10, -34];
    }

    var marker = new ymaps.Placemark([point_coords[0], point_coords[1]], {}, {
        iconLayout: 'default#image',
        iconImageHref: '/d/img/icons/map_marker.svg',
        iconImageSize: iconImageSize,
        iconImageOffset: iconImageOffset
    });

    map_object.geoObjects.add(marker);

    return marker;
}

$(function(){
    var params = {
        'lazyLoad': 'ondemand',
        'slidesToShow': 4, 
        'slidesToScroll': 1,
        'respondTo': 'slider', 
        'infinite': false, 
        'responsive':[
            {
                'breakpoint': 1200,
                'settings': {
                    'slidesToShow': 3
                }
            },
            {
                'breakpoint': 767,
                'settings': {
                    'slidesToShow': 2
                }
            },
            {
                'breakpoint': 420,
                'settings': {
                    'slidesToShow': 1
                }
            }
        ]
    };

    $('.simple_slider').slick(params);

    Fancybox.bind("a.fancy");

    if(ww>=1024){
        $('.show_beauty').each(function(){
            show_beauty_in(this);
        });
    }
});

$(document).on("click", 'a[href*=\\#]', function(e){
    e.preventDefault();

    var anchor = $(this);
    var href = anchor.attr('href');
    if(!href || href == '#') return;
    $('html, body').stop().animate({
        scrollTop: $(anchor.attr('href')).offset().top
    }, 1000);
});


function show_beauty_in(elem){
    if(!elem) return;

    var types = ['circle', 'star', 'spiral'];
    var colors = ['#D3CEED', '#FEAA7D', '#FCD7BF', '#D6EDD9'];
    var sizes_count = 3;
    var beauties_count = 4;

    for(var i=0;i<beauties_count;i++){
        var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        var chosen_type = types[Math.floor(Math.random()*types.length)];
        var chosen_color = colors[Math.floor(Math.random()*colors.length)];
        var chosen_size = Math.floor(Math.random()*sizes_count);

        var use = document.createElementNS('http://www.w3.org/2000/svg', 'use');
        use.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '#beauty-'+chosen_type);
        svg.append(use);

        svg.classList.add('svg-beauty', 'type-'+chosen_type, 'size'+chosen_size);
        svg.style.color = chosen_color;

        var position = gen_position();
        for(var p in position){
            svg.style[p] = position[p]+'%';
        }

        elem.prepend(svg);
    }
}

function gen_position(){
    var vert_padding = 10;
    var horiz_padding = 10;

    var gen_top = Math.floor(Math.random()*100);
    var gen_left = 0;

    if(gen_top<vert_padding || gen_top>100-vert_padding){
        gen_left = Math.floor(Math.random()*100);
    }else{
        var temp_left = Math.floor(Math.random()*horiz_padding*2);
        temp_left = horiz_padding-temp_left;
        if(temp_left>=0)
            gen_left = temp_left;
        else
            gen_left = 100 + temp_left;
    }

    var position = {};
    if(gen_top>50) position['bottom'] = 100-gen_top;
    else position['top'] = gen_top;

    if(gen_left>50) position['right'] = 100-gen_left;
    else position['left'] = gen_left;

    return position;
}